import { bool, func } from 'prop-types';
import Styled from './burger-style';

/**
 * Burger component.
 * @param {object} props the Props.
 * @param {boolean} props.open The open.
 * @param {func} props.setOpen The set open.
 * @returns {JSX.Element} The rendered Burger component.
 */
const Burger = ({ open, setOpen }) => (
  <Styled.Burger open={open} onClick={() => setOpen(!open)} name="nav-toggle">
    <Styled.Line />
    <Styled.Line />
    <Styled.Line />
  </Styled.Burger>
);

Burger.propTypes = {
  open: bool.isRequired,
  setOpen: func.isRequired,
};

export default Burger;
